import React from "react";
import TeamMenu from "../../components/teamMenu/TeamMenu";
import TableTeamRoles from "../../components/tableTeamRoles/TableTeamRoles";

const TeamRoles = () => {
  return (
    <>
      <TeamMenu>
        <TableTeamRoles />
      </TeamMenu>
    </>
  );
};

export default TeamRoles;
